import { useMediaQuery } from "@mui/material";
import { APP_LEFT_DRAWER_EXPANDED_WIDTH } from "./createShared";
import { compactDashboardContentTopPadding } from "./common/SettingsBackButton";

const CHARACTER_DRAWER_STORAGE_KEY = "fable-create-character-drawer-open";

// Match Gambit's progress rail at the same viewport breakpoints.
const characterRailWidths = { desktop: 82, tablet: 68, phone: 56 };
export const characterRailSizingSx = {
  "--character-rail-width": `${characterRailWidths.desktop}px`,
  "--character-rail-item-size": "36px",
  "--character-rail-avatar-size": "30px",
  "--character-rail-heading-height": "84px",
  "--character-rail-icon-size": "20px",
  "@media (max-width: 1199px)": { "--character-rail-width": `${characterRailWidths.tablet}px` },
  "@media (max-width: 699px)": {
    "--character-rail-width": `${characterRailWidths.phone}px`,
    "--character-rail-item-size": "32px",
    "--character-rail-avatar-size": "26px",
    "--character-rail-heading-height": "66px",
    "--character-rail-icon-size": "18px",
  },
};

export function useCollapsedCharacterRailWidth() {
  const phone = useMediaQuery("(max-width:699px)");
  const compact = useMediaQuery("(max-width:1199px)");
  return phone ? characterRailWidths.phone : compact ? characterRailWidths.tablet : characterRailWidths.desktop;
}

export const CREATE_STORY_VIEWPORT_MIN_HEIGHT =
  "calc(100dvh - var(--fable-dashboard-header-height))";

export const getStoredCharacterDrawerOpen = () => {
  if (typeof window === "undefined") return true;
  try {
    return (
      window.localStorage.getItem(CHARACTER_DRAWER_STORAGE_KEY) !== "closed"
    );
  } catch (error) {
    console.warn("Unable to read character drawer preference", error);
    return true;
  }
};

export const persistCharacterDrawerOpen = (open: boolean) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      CHARACTER_DRAWER_STORAGE_KEY,
      open ? "open" : "closed",
    );
  } catch (error) {
    console.warn("Unable to save character drawer preference", error);
  }
};

/** Share the ready/loading geometry so the header and composer never jump sideways. */
export const getCreateStoryContentSx = (expanded: boolean) => ({
  minHeight: CREATE_STORY_VIEWPORT_MIN_HEIGHT,
  // Match Gambit's conversation gutters outside the shared StoryComposer.
  "--create-conversation-gutter": "24px",
  pl: expanded ? {
    xs: "calc(var(--character-rail-width) + var(--create-conversation-gutter))",
    lg: `calc(${APP_LEFT_DRAWER_EXPANDED_WIDTH}px + var(--create-conversation-gutter))`,
  } : "calc(var(--character-rail-width) + var(--create-conversation-gutter))",
  pr: "var(--create-conversation-gutter)",
  "@media (max-width: 1399px)": {
    "--create-conversation-gutter": "22px",
  },
  "@media (max-width: 699px)": {
    "--create-conversation-gutter": "14px",
  },
  py: compactDashboardContentTopPadding,
});
